/* Consider moving to a more feature focused area */

import React, { FC } from "react"
import { ContentfulContentRenderer } from "../content-renderer"
import styled from "styled-components"
import { ITwoColumnLayout } from "contentful-types"
import { ContentfulContentProp } from "./shared-types"

const TwoColumnLayoutWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
  max-width: 550px;
  div {
    &.two-col-child {
      width: calc(50% - 16px);
    }
  }
`

export const TwoColumnLayout: FC<ContentfulContentProp<ITwoColumnLayout>> = ({
  content: {
    fields: { content }
  }
}) => {
  return (
    <TwoColumnLayoutWrapper>
      <ContentfulContentRenderer contents={content} childClasses="two-col-child" />
    </TwoColumnLayoutWrapper>
  )
}
